import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo, setIsMiniDashboardOpen } from "@/reducers/commonSlice";
import CardComponent from "@/components/card";
import IconCross from "@/components/icons/IconCross";
import { Flex } from "antd";

const UserCard = () => {
  const dispatch = useDispatch();
  const userData = useSelector(getUserInfo);
  const isGuideRole = userData?.roles?.find((x) => x.name === "Guide");
  return (
    <div className="header">
      <CardComponent>
        <div className="header-content">
          <div className="user-info">
            <div className="profile-picture">
              <img
                src={
                  userData.profileImgUrl
                    ? userData.profileImgUrl
                    : "/assets/images/defaultProfile.jpeg"
                }
                alt="User Profile"
                style={{ borderRadius: "50%" }}
              />
            </div>
            <Flex vertical>
              <div className="welcome-message body-b2">
                Welcome back, {userData?.user?.firstName}
              </div>
              {isGuideRole && !isGuideRole.isApproved && (
                <div className="color-brand">Your Mentor request is under review</div>
              )}
            </Flex>
          </div>

          <div className="close-button" onClick={() => dispatch(setIsMiniDashboardOpen(false))}>
            <IconCross color="#1C1C2C" width={50} heght={50} />
          </div>
        </div>
      </CardComponent>
    </div>
  );
};

export default UserCard;
